import { useSearchParams } from 'next/navigation';
import { CONCERTS_ID } from './util';

export function useIsConcerts() {
  const searchParams = useSearchParams();
  const parentId = searchParams?.get('parentId');

  const isConcerts = CONCERTS_ID.includes(Number(parentId));

  return isConcerts;
}
